module.exports = __webpack_public_path__ + "img/icon_status_yellow_fill_small.8ef459ca.svg";